define('views/layouts/content/layout-info',[
    // Libs
    'underscore', 'backbone', 'mustache',
    'utils',
    // src
    'src/queue/delay-queue',
    // events
    'services/layout',
    // views
    'views/layouts/layout-overlay-stack',
    // templates
    'text!templates/layouts/content/layout-info.html',

], function(
    // Libs
    _, Backbone, Mustache, U,
    // src
    DelayQueue,
    // events
    LayoutState,
    // views
    VLayoutOverlayStack,
    // templates
    TLayoutInfo
) {

    var VLayoutInfo = Backbone.View.extend({
        template: TLayoutInfo,
        className: "layout overlay-background",
        regions: {
            content: '#info-content',
            drawer: '#info-drawer',
        },

        initialize: function(opt) {
            opt = opt || {};

            this.queue = new DelayQueue({ delay: 200, context: this });

            var view = this.view = {
                drawer: new VLayoutOverlayStack(),
            };
            this.content = opt.view;

            this.listenTo(this.content, {
                'back': this.onBack,
                'drawer:view': this.setDrawer
            });
            this.listenTo(view.drawer, {
                "back": this.onBack
            });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template));

            this.generateZones()
                .renderView('drawer')
                .setViewTo(this.content, this.zone.$content);

            return this;
        },

        is: function(view) {
            return this.getView() === view;
        },

        getView: function() {
            return this.content;
        },

        getDrawer: function() {
            return this.view.drawer;
        },

        // DRAWER
        isDrawerOpened: function() {
            var zone = this.zone;
            return zone && zone.$drawer.hasClass('open');
        },
        toggleDrawer: function(val) {
            var condition = function() {
                return this.isDrawerOpened() !== val;
            };
            return this.queue.add(this._toggleDrawer, val, {
                    condition: condition
                })
                .done(this._afterDrawerToggle);
        },

        _toggleDrawer: function(val) {
            if (this.zone) {
                this.zone.$drawer.toggleClass('open', open);
                this.trigger('drawer:toggle', this.isDrawerOpened());
            }
        },

        _afterDrawerToggle: function() {
            // trigger an event after as a hook for other views
            LayoutState.setState('info.drawer', open);
        },

        setDrawer: function(view, open) {
            open = _.isUndefined(open) ? this.isDrawerOpened() : open;
            var drawer = this.view.drawer;

            if (drawer.is(view)) {
                this.toggleDrawer(open);
            } else {
                drawer.set(view, open).always(function() {
                    this.toggleDrawer(open !== false);
                    view.onOpen(open !== false);
                }.bind(this));
            }
        },

        onBack: function() {
            this.toggleDrawer(false);
            this.trigger('back');
        }

    });

    return VLayoutInfo;

});

